import { makeRequest } from "../http-common";

const ExportDataService = {
  async policies() {
    return makeRequest("get", `/export/policies?export=start`, { responseType: 'blob' });
  },

  async mailinglist() {
    return makeRequest("get", `/export/mailinglist?export=start`, { responseType: 'blob' });
  },
};

export default ExportDataService;
